<template>
  <div class="bg">
    <div :style="{background:dynamicColor.rgb}" class="bacColor">
      <img src="../../../static/images/bg_1.png" alt="">
    </div>
    <div class="returnBut" @click="returnBut">
      <img src="../../../static/images/return_b.png" alt="">
      <p>返回</p>
    </div>
    <div class="information">
      <div>
        <p>可提{{bonusRealName}}</p>
        <p>{{dividendInformation.bonus}}</p>
      </div>
      <div>
        <p>累计提现</p>
        <p>{{dividendInformation.totalCash}}</p>
      </div>
    </div>
    <div class="withdrawalsRecord" @click="withdrawalsRecord">提现记录></div>
    <div class="wrapCon">
      <div class="con">
        <h3 class="title">提现金额</h3>
        <div class="amount">
          <div>
            <h1>￥</h1>
            <input type="number" v-model="amount" placeholder="0.00">
          </div>
          <p>最小提现金额0元</p>
        </div>
        <div class="allWithdraw">
          <p>预计1个工作日到账&nbsp;,&nbsp;可提现{{dividendInformation.bonus}}元</p>
          <p @click="all" :style="{color:dynamicColor.rgb}">全部提现</p>
        </div>
        <div>
          <h3 class="title theWay">提现方式</h3>
          <div class="tab">
            <p :class="tabStat == 0?'tabOn':''"
               :style="{background:tabStat == 0?dynamicColor.rgba:'',color:tabStat == 0?dynamicColor.rgb:''}"
               @click="tab(0)">支付宝</p>
            <p :class="tabStat == 1?'tabOn':''"
               :style="{background:tabStat == 1?dynamicColor.rgba:'',color:tabStat == 1?dynamicColor.rgb:''}"
               @click="tab(1)">银行卡</p>
          </div>
          <div class="inpList" v-if="tabStat == 0">
            <div>
              <input class="inps" type="text" v-model="userName" placeholder="姓名">
            </div>
            <div>
              <input class="inps" type="text" v-model="accountNumber" placeholder="支付宝账号">
            </div>
          </div>
          <div class="inpList" v-if="tabStat == 1">
            <div>
              <input class="inps" type="text" v-model="accountName" placeholder="银行户名">
            </div>
            <div>
              <input class="inps" type="text" v-model="bankAccount" placeholder="银行卡账号">
            </div>
            <div>
              <input class="inps" type="text" v-model="accountBank" placeholder="开户行">
            </div>
          </div>
          <button class="but" @click="withdrawBut" :style="{background:dynamicColor.rgb}">提现</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {Toast} from 'vant';

  export default {
    components: {Toast},
    name: "index",
    data() {
      return {
        tabStat: 0,
        dividendInformation: {},
        amount: '',
        apiName: '',
        userName: '', //支付宝姓名
        accountNumber: '',//支付宝账户
        accountName: '', //银行户名
        bankAccount: '',//银行卡账号
        accountBank: '', //开户行
        dynamicColor: {},
        bonusRealName: '分红',
        contributionRealName: '贡献'
      }
    },
    created() {
      this.dynamicColor = JSON.parse(localStorage.getItem('bakColor'));
      this.dividendInformation = this.$store.state.userData == '{}' ? this.$store.state.userData : JSON.parse(localStorage.getItem('userData'));
      this.apiName = this.API1url.API;

      this.$get(this.apiName.realNameData, { // 获取分红、贡献真名
        token: this.$store.state.parameterUrl
      }).then(res => {
        if (res.code == '0000') {
          // this.platformContribution = res.data;
          this.bonusRealName = res.data.bonusRealName != null ? res.data.bonusRealName : '分红';
          this.contributionRealName = res.data.contributionRealName != null ? res.data.contributionRealName : '贡献';
        } else {
          Toast.fail('加载失败');
        }
      })
    },
    methods: {
      tab(e) {
        this.tabStat = e;
      },
      withdrawalsRecord() { //提现记录
        this.$router.replace('/WithdrawalsRecord')
      },
      returnBut() {
        this.$router.replace('/Dividends');
      },
      all() {
        if (this.dividendInformation.bonus > 0) {
          this.amount = this.dividendInformation.bonus
        } else {
          Toast('暂无金额');
        }
      },
      withdrawBut() {
        if (this.amount <= 0) {
          Toast('请输入正确金额');
          return false
        }
        if (this.tabStat == 0) {
          if (this.userName == '') {
            Toast('请输入支付宝姓名');
            return false;
          } else if (this.accountNumber == '') {
            Toast('请输入支付宝账户');
            return false;
          }
          this.$post(this.apiName.alipayWithdrawal, { //支付宝提现
            token: localStorage.getItem('token'),
            name: this.userName,
            AliPayNo: this.accountNumber,
            bonus: Number(this.amount)
          }).then(res => {
            console.log(res, "?????")
            if (res.code == '0000') {
              Toast('提现申请成功');
              setTimeout(() => {
                this.userName = '';
                this.accountNumber = '';
              }, 1500)

            }
          }).catch(err => {
            Toast('加载失败');
          })
        } else {
          if (this.accountName == '') {
            Toast('请输入银行户名');
            return false;
          } else if (this.bankAccount == '') {
            Toast('请输入银行卡账号');
            return false;
          } else if (this.accountBank == '') {
            Toast('请输入开户行');
            return false;
          }
          this.$post(this.apiName.bankCardWithdrawal, {//银行卡提现
            bankName: this.accountName,
            cardNo: this.bankAccount,
            openingBank: this.accountBank,
            name: '',
            bonus: Number(this.amount)
          }).then(res => {
            // console.log(res,"?????")
            if (res.code == '0000') {
              Toast('提现申请成功');
              setTimeout(() => {
                this.accountName = '';
                this.bankAccount = '';
                this.accountBank = '';
              }, 1500)
            }
          }).catch(err => {
            Toast('加载失败');
          })
          this.amount = '';
        }
      }
    }
  }
</script>

<style scoped>
  .bg {
    width: 100%;
    height: 100%;
    /*position: fixed;*/
    /*left: 0;*/
    /*top: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*background: url("/static/images/bg1.png") no-repeat;*/
    /*background-size: 100% 100%;*/
    overflow-y: scroll;
    position: relative;
  }

  .bacColor {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 668px;
    z-index: -1;
  }

  .bacColor > img {
    width: 100%;
    height: 100%;
  }

  .information {
    display: flex;
    margin: 76px 0 0 32px;
  }

  .information > div:nth-child(1) {
    margin-right: 43px;
  }

  .information > div > p:nth-child(1) {
    color: #FFFFFF;
    font-size: 14px;
    margin-bottom: 5px;
    text-align: center;
  }

  .information > div > p:nth-child(2) {
    color: #FFFFFF;
    font-size: 25px;
    font-family: FZCYJ;
    text-align: center;
  }

  .withdrawalsRecord {
    font-size: 14px;
    color: #FFFFFF;
    font-weight: bold;
    margin: 16px 0 0 32px;
  }

  .wrapCon {
    width: 93%;
    background: #FFFFFF;
    margin: 24px auto;
    overflow: hidden;
  }

  .con {
    width: 90%;
    margin: 40px auto;
    padding-bottom: 52px;
  }

  .title {
    font-size: 18px;
    margin-bottom: 13px;
  }

  .amount {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .amount > div {
    display: flex;
    height: 40px;
    align-items: center;
  }

  .amount > div > h1 {
    font-size: 28px;
  }

  input {
    outline: none;
    -webkit-appearance: none; /*去除系统默认的样式*/
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
  }

  .amount > div > input {
    border: none;
    /*height: 30px;*/
    margin-top: 5px;
    font-size: 28px;
    color: #000000;
    width: 100px;
    font-weight: bold;
    padding-left: 5px;
  }

  .amount > div > input::placeholder {
    font-size: 28px;
    color: #e7e7e7;
  }

  .amount > p {
    font-size: 12px;
    color: #7a7a7a;
  }

  .allWithdraw {
    display: flex;
    margin-top: 21px;
    justify-content: space-between;
  }

  .allWithdraw > p:nth-child(1) {
    font-size: 12px;
    color: #000000;
  }

  .allWithdraw > p:nth-child(2) {
    font-size: 12px;
    /*color: #2f80ed;*/
  }

  .theWay {
    margin-top: 48px;
  }

  .tab {
    display: flex;
    margin: 16px 0 12px 0;
  }

  .tab > p {
    width: 60px;
    height: 24px;
    border-radius: 14px;
    text-align: center;
    line-height: 24px;
    font-size: 12px;
  }

  .tabOn {
    /*background: #ebf3fe;*/
    /*color: #2f80ed;*/
  }

  .inpList {
    width: 100%;
    overflow: hidden;
    margin-bottom: 24px;
  }

  .inps {
    width: 296px;
    height: 44px;
    border-radius: 22px;
    border: 1px solid #ebebeb;
    padding-left: 16px;
    font-size: 16px;
    margin-bottom: 12px;
  }

  .but {
    width: 296px;
    height: 48px;
    border-radius: 24px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    font-size: 16px;
    /*background: #2f80ed;*/
    border: none;
  }

  .returnBut {
    position: absolute;
    left: 20px;
    top: 16px;
    z-index: 99;
    display: flex;
    align-items: center;
  }

  .returnBut > img {
    width: 20px;
    height: 18px;
  }

  .returnBut > p {
    color: #ffffff;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/withdraw/index.vue